	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Material.UniformResolverRegistry;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Material/UniformResolverRegistry.js
// module id = 21
// module chunks = 0